import { PrimaryButton } from "../AllButtons/AllButtons";
import RightCheckIcon from "../../assets/images/vactor/sm-select-right.svg";
// import "../../pages/UserProfile/UserProfile.scss";
import "../ChangePassword/ChangePassword.scss";
import { useNavigate } from "react-router-dom";
const PasswordReset = () => {
    const navigate = useNavigate() ; 
    return (
        <>
            <div className="successfully-reset-body">
                <div className="successfully-reset-icon">
                    <img src={RightCheckIcon} alt="" />
                </div>
                <div className="successfully-dsc-block">
                    <div className="successfully-title">Password Successfully Reset</div>
                    <div className="successfully-dsc">Your password has been updated. Sign in to continue learning with YULI.</div>
                </div>
                <div className="successfully-reset-action">
                    <PrimaryButton 
                    onClick={() => navigate("/login") }> Sign in </PrimaryButton>
                </div>
            </div>

        </>
    )
}

export default PasswordReset; 